module.exports = __webpack_public_path__ + "static/media/access_230.ff34fc62.ico";